import React, { useEffect } from "react";
import { setPageTitle } from "../app/features/DataSlice";
import { useDispatch } from "react-redux";
import TokenBalance from "../components/blockchain/TokenBalance";
import NFTBalance from "../components/blockchain/NFTBalance";

const Blockchains = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageTitle("Blockchain"));
  });
  return (
    <>
      <TokenBalance />
      <NFTBalance />
    </>
  );
};

export default Blockchains;
